<template>
	<div class="dashboard-content">
		<div v-if="isLoading" class="loading-data">
			<b-spinner variant="light" label="Get Data"></b-spinner> loading...
		</div>
		<div id="row1" class="row row1 m-0">
			<ColumnViewer idName="column3" className="column3 col-4 p-0">
				<div id="card6">
					<CardViewer className="card6 d-flex justify-content-between align-items-center">
						<TextViewer idName="text9" value="STOCK LEVEL" className="text9" />
						<TextViewer idName="text10" :value="currentTime" className="text9" />
					</CardViewer>
				</div>
			</ColumnViewer>
			<ColumnViewer idName="column4" className="column4 col-8 p-0">
				<div id="card5">
					<CardViewer className="card5 d-flex justify-content-center align-items-center">
						<TextViewer idName="text7" value="STOCK ACHIEVEMENT" className="text7" />
					</CardViewer>
				</div>
			</ColumnViewer>
		</div>
		<div id="row10" class="row row10 m-0">
			<ColumnViewer idName="column17" className="column17 col-4 p-0 d-flex flex-column">
				<div id="card18">
					<CardViewer className="card18">
						<TextViewer idName="text20" value="MINES STOCK TOTAL" className="text20" />
					</CardViewer>
				</div>
				<div id="card19" class="flex-grow-1">
					<CardViewer className="card19 h-100 d-flex justify-content-center align-items-center">
						<TextViewer idName="text21" :value="this.dataDashboard.minesStockTotal != null && this.dataDashboard.minesStockTotal != undefined ? formatNumber(this.dataDashboard.minesStockTotal[0].count) : 0 + ' ITEM'" className="text21" />
					</CardViewer>
				</div>
			</ColumnViewer>
			<ColumnViewer idName="column22" className="column22 col-8  p-0">
				<CustomerList :items="this.dataDashboard.customerList" />
			</ColumnViewer>
		</div>
		<div id="row11" class="row row11 ">
			<ColumnViewer idName="column13" className="column13 col-12">
				<div id="card14">
					<CardViewer className="card14">
						<div class="d-flex justify-content-between">
							<TextViewer idName="text15" :value="`SHORTAGE ITEM LIST ${currentCustomerCode}`" className="text15" />
							<div v-if="isTableLoading" class="loading-table-data mr-1">
								<b-spinner variant="light" label="Get Data" class="mr-1" small></b-spinner> loading...
							</div>
						</div>
						<div class="table-responsive">
							<TableViewer 
								idName="table16" className="table16" 
								:data="tableList" :fields="tableFields"
								noDataMessage="Tidak ada data Shortage Item"
								:sticky-header="true"
								ref="scrollContainer"
								>
								<template v-slot:cell(no)="row">
									{{ row.index + 1 }}
								</template>
								<template v-slot:cell(part_name)="row">
									<app-long-text :maxLength="14" :mdMaxLength="14" :text="row.item.part_name != '' && row.item.part_name != null ? row.item.part_name : ''" />
								</template>
								<template v-slot:cell(standart_per_day)="row">
									<div class="text-td-success">{{ row.item.standart_per_day | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(stock_awal)="row">
									<div class="text-td-warning">{{ row.item.stock_awal | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(actual_in)="row">
									<div class="text-td-warning">{{ row.item.actual_in | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(actual_out)="row">
									<div class="text-td-warning">{{ row.item.actual_out | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(plan_out)="row">
									<div class="text-td-warning">{{ row.item.plan_out | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(sisa_stock)="row">
									<div class="text-td-warning">{{ row.item.sisa_stock | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(delay)="row">
									<div class="text-td-full-danger">{{ row.item.delay | thousandSeparator }}</div>
								</template>
								<template v-slot:cell(gap)="row">
									<div class="text-td-danger">{{ row.item.gap | thousandSeparator }}</div>
								</template>
							</TableViewer>
						</div>
					</CardViewer>
				</div>
			</ColumnViewer>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/dashboard-page.scss';
@import '../../assets/dashboardcss/andonstock.scss';

::v-deep .table thead th {
    min-width: fit-content !important;
}

.loading-table-data {
    z-index: 1;
    background: #CCC;
    display: flex;
    padding: 4px;
    align-items: center;
    border-radius: 5px;
    opacity: 0.9;
}
</style>
<script>
import RowViewer from '@/components/dashboard/RowViewer';
import ColumnViewer from '@/components/dashboard/ColumnViewer';
import CardViewer from '@/components/dashboard/CardViewer';
import TextViewer from '@/components/dashboard/TextViewer';
import ListViewer from '@/components/dashboard/ListViewer';
import TableViewer from '@/components/dashboard/TableViewer';
import { thousandSeparator } from '@/utils/thousandSeparator';
import CustomerList from './components/CustomerList';

export default {
	components: {
		RowViewer, ColumnViewer, CardViewer, TextViewer, ListViewer, TableViewer, CustomerList
	},
	data() {
		return {
			isLoading: false,
			dataDashboard: [],
			currentTime: "",
			tableFields : [
				{ "no": {}, "label": "#", key: 'no' },
				{ "partNo": {}, "class": "th-code", "label": "PART NO", key: 'part_number' },
				{ "partName": {}, "class": "th-name", "label": "PART NAME", key: 'part_name' },
				{ "std": {}, "class": "th-name th-currency", "label": "STD / DAY", key: 'standart_per_day'},
				{ "sto": {}, "class": "th-name th-currency", "label": "BEG. STOCK", key: 'stock_awal'},
				{ "plnOut": {}, "class": "th-name th-currency", "label": "PLN OUT", key: 'plan_out'},
				{ "actIn": {}, "class": "th-name th-currency", "label": "ACT IN", key: 'actual_in'},
				{ "actOut": {}, "class": "th-name th-currency", "label": "ACT OUT", key: 'actual_out'},
				{ "stock": {}, "class": "th-name th-currency", "label": "END STOCK", key: 'sisa_stock'},
				{ "gap": {}, "class": "th-name th-currency", "label": "GAP", key: 'gap'},
				{ "customer": {}, "class": "th-name", "label": "CUSTOMER", key: 'customer'},
			],
			isFirstCustomer: false,
			isTableLoading: false,
			tableList: [],
			scrollAmount: 1,
      		scrollInterval: 50,
			customerIndex: 0,
			isFirstCustomer: false,
			currentCustomerCode: '',
		}
	},
	mounted() {
		this.getAndonStockData();
		this.runDateTime();
		this.getAndonInterval();
	},
	methods: {
		getAndonStockData() {
			this.isLoading = true;
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonstockdata`).then(result => {
				if (result != null) {
					this_.dataDashboard = result.data;
					this_.customerList = result.data.customerList;
					if (this_.customerList.length > 0) {
						if (!this_.isFirstCustomer) {
							this_.getAndonTableStockData(this_.customerList[0].code);
						}
					}
				}
				this_.isLoading = false;
				return true;
			}).catch(function (error) {
				this_.isLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		getAndonTableStockData(customerCode) {
			this.isTableLoading = true;
			this.currentCustomerCode = customerCode;
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandontablestockdata/${customerCode}`).then(result => {
				if (result != null) {
					this_.tableList = result.data.tableList;
					this_.customerIndex++;
					
					setTimeout(() => {
						this_.startAutoScroll();
					}, 2000);
				}
				this_.isTableLoading = false;
				return true;
			}).catch(function (error) {
				this_.isTableLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		startAutoScroll() {
			let this_ = this;
			this.scrollIntervalId = setInterval(() => {
				if (this_.$refs.scrollContainer == null || this_.$refs.scrollContainer == undefined) {
					this_.stopAutoScroll();
					return;
				}
				if (this_.$refs.scrollContainer.$el == null || this_.$refs.scrollContainer.$el == undefined) {
					this_.stopAutoScroll();
					return;
				}
				if (this_.$refs.scrollContainer.$el.scrollTop == null || this_.$refs.scrollContainer.$el.scrollTop == undefined) {
					this_.stopAutoScroll();
					return;
				}
				this_.isFirstCustomer = true;
				this_.$refs.scrollContainer.$el.scrollTop += this_.scrollAmount;
				
				if (
					this_.$refs.scrollContainer.$el.scrollTop + 
					this_.$refs.scrollContainer.$el.clientHeight >= 
					this_.$refs.scrollContainer.$el.scrollHeight
				) {
					this_.stopAutoScroll();
					if (this_.customerIndex >= this_.customerList.length) {
						this_.customerIndex = 0;
					}
					if (this_.tableList.length <= 8 && this_.tableList.length > 0) {
						setTimeout(() => {
							this_.getAndonTableStockData(this_.customerList[this_.customerIndex].code);
						}, 8000);
					} else {
						this_.getAndonTableStockData(this_.customerList[this_.customerIndex].code);
					}
				}
			}, this.scrollInterval);
		},
		stopAutoScroll() {
			clearInterval(this.scrollIntervalId);
		},
		getAndonInterval() {
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonrefreshinterval`).then(result => {
				if (result != null) {
					if(result.data != null) {
						if (result.data.interval != null && result.data.interval != undefined
							 && result.data.interval > 0) {
							this_.runAutorefresh(result.data.interval);
						}
					}
				}
				return true;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		runDateTime() {
			setInterval(() => {
				const now = new Date();
				const day = String(now.getDate()).padStart(2, '0');
				const month = String(now.getMonth() + 1).padStart(2, '0');
				const year = now.getFullYear();
				const hours = String(now.getHours()).padStart(2, '0');
				const minutes = String(now.getMinutes()).padStart(2, '0');
				const seconds = String(now.getSeconds()).padStart(2, '0');
				this.currentTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
			}, 1000);
		},
		runAutorefresh(interval) {
			let this_ = this;
			setInterval(() => {
				this_.getAndonStockData();
			}, (1000 * 60 * interval));
		},
		formatNumber(value) {
            return thousandSeparator(value);
        }
	},
}
</script>